
export default {
  data() {
    return {

      form : {
                id : '',
                nama : '',
                alamat : '',
                hp : '',
                email : '',
                nik : '',
                ktp : null,
                status : '',
                keterangan : '',
                rekomendasi : null,
                nomorP : '',
                tanggalP : '',
                namaP : '',
                jabatanP : '',
                suratP : null,
                statusP : '',
                nomorR : '',
                tanggalR : '',
                namaR : '',
                jabatanR : '',
                suratR : null,
                statusR : '',
                judul : '',
                lokasi : '',
                tujuan : '',
                lingkup : '',
                tgl_mulai : '',
                tgl_selesai : '',
                proposal : null,
                kategori_id : '',
                statusPro : '',
                laporan : null,
                survey : '',
                userId : '',
                createAt : '',
                editedAt : '',
                createBy : '',
                ktp_old : null,
                rekomendasi_old : null,
                suratP_old : null,
                suratR_old : null,
                proposal_old : null,
                kategori_uraian : ''
            },
     
      list_data : [],
      list_kategori : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_agree: false,
      mdl_publish: false,
      mdl_tolak: false,
      mdl_open: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,

      mdl_rekomendasi: false,
      mdl_pengantar: false,
      mdl_penelitian : false,
      mdl_laporan : false,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_VerifikasiPenelitian + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              kategori_id : this.kategori_id,
            userId : this.userId,
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(this.list_data);
      });
    },

    getKategori: function() {
        fetch(this.$store.state.url.URL_Kategori, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
            // console.log('telasooooo')
        this.list_kategori = res_data;
        // console.log(this.list_kategori)
        });
    },


    addData : function() {
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      // formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)

      // console.log(formData);

      fetch(this.$store.state.url.URL_Usulan + "addData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },


    editData : function(){
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_Usulan + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(a, b, c, d, e, f, g){
      // console.log(a);
      // console.log(b);
      fetch(this.$store.state.url.URL_Penelitian + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a, ktp : b, suratP : c, suratR : d, proposal : e, rekomendasi : f, laporan : g})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
        this.form.id = data.id
        this.form.nama = data.nama
        this.form.alamat = data.alamat
        this.form.hp = data.hp
        this.form.email = data.email
        this.form.nik = data.nik
        this.form.ktp = data.ktp
        this.form.status = data.status
        this.form.keterangan = data.keterangan
        this.form.rekomendasi = data.rekomendasi
        this.form.nomorP = data.nomorP
        this.form.tanggalP = data.tanggalP
        this.form.namaP = data.namaP
        this.form.jabatanP = data.jabatanP
        this.form.suratP = data.suratP
        this.form.statusP = data.statusP
        this.form.nomorR = data.nomorR
        this.form.tanggalR = data.tanggalR
        this.form.namaR = data.namaR
        this.form.jabatanR = data.jabatanR
        this.form.suratR = data.suratR
        this.form.statusR = data.statusR
        this.form.judul = data.judul
        this.form.lokasi = data.lokasi
        this.form.tujuan = data.tujuan
        this.form.lingkup = data.lingkup
        this.form.tgl_mulai = data.tgl_mulai
        this.form.tgl_selesai = data.tgl_selesai
        this.form.proposal = data.proposal
        this.form.kategori_id = data.kategori_id
        this.form.statusPro = data.statusPro
        this.form.survey = data.survey
        this.form.userId = data.userId
        this.form.createBy = data.createBy
        this.form.createAt = data.createAt
        this.form.kategori_uraian = data.kategori_uraian
        this.form.laporan = data.laporan
        // this.form.rekomendasi_old =  data.rekomendasi
        // this.form.ktp_old =  data.ktp
    },

    terima_data : function(){
      var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))
      formData.append('rekomendasi', this.form.rekomendasi)


        fetch(this.$store.state.url.URL_VerifikasiPenelitian + "terima_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menyetujui Penelitian', 'blue', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
    },

    kembalikan_data : function(){
        var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))


        fetch(this.$store.state.url.URL_VerifikasiPenelitian + "kembalikan_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Mengembalikan Penelitian', 'warning', 'check_circle_outline');
            this.getView();
        });
    },

    publish_data : function(){
        var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))


        fetch(this.$store.state.url.URL_VerifikasiPenelitian + "publish_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Publish Data Penelitian', 'secondary', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },
        convert_tgl: function(dateString) {
                    var date = new Date(dateString);
                    var getBulan = date.getMonth() + 1; var bulan = '';
                    if (getBulan == '1') {bulan = 'Januari'} 
                    else if(getBulan == '2') {bulan = 'Februari'}
                    else if(getBulan == '3') {bulan = 'Maret'}
                    else if(getBulan == '4') {bulan = 'April'}
                    else if(getBulan == '5') {bulan = 'Mei'}
                    else if(getBulan == '6') {bulan = 'Juni'}
                    else if(getBulan == '7') {bulan = 'Juli'}
                    else if(getBulan == '8') {bulan = 'Agustus'}
                    else if(getBulan == '9') {bulan = 'September'}
                    else if(getBulan == '10') {bulan = 'Oktober'}
                    else if(getBulan == '11') {bulan = 'November'}
                    else if(getBulan == '12') {bulan = 'Desember'}



                    return date.getDate() + " " + bulan + " " + date.getFullYear();
                    // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                }


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    this.form.userId = get_profile.profile.userId;
    this.form.email = get_profile.profile.email;
    this.getKategori();
    this.getView();
    // this.getPengantar();
  },
}
